const requestTypeOptions = (isGarage: boolean) =>
  [
    { id: 1, title: "Demande d'informations" },
    { id: 2, title: "Demande d'annulation de Rendez-vous" },
    { id: 3, title: 'Réclamation' },
    { id: 4, title: 'Prise de contact Commercial' },
    { ...(isGarage && { id: 5, title: 'Contacter un garage' }) },
    { id: 6, title: 'Autres' },
  ].filter((item) => item.id);

export default requestTypeOptions;
